// API Client - barrel file re-exporting all modules
// This preserves backward compatibility with `import { api } from '../../api/client'`

import { setToken, getToken } from './base';
import * as authCore from './modules/auth-core';
import * as commerce from './modules/commerce';
import * as procurementQuality from './modules/procurement-quality';
import * as labOperations from './modules/lab-operations';
import * as integrations from './modules/integrations';
import * as workflowsCrm from './modules/workflows-crm';
import * as advancedQuality from './modules/advanced-quality';
import * as compliance from './modules/compliance';

export const api = {
  setToken,
  getToken,
  ...authCore,
  ...commerce,
  ...procurementQuality,
  ...labOperations,
  ...integrations,
  ...workflowsCrm,
  ...advancedQuality,
  ...compliance,
} as const;

// Re-export types that pages import directly
export type { EmailMessage, EmailAttachment, EmailMessageWithBody, ContextaJob, ContextaJobWithContent } from './modules/integrations';
